const resources = {
    showMore: 'Show more',
    rougeBadge: 'ROUGE EXCLUSIVE'
};

export default function getResource(label) {
    return resources[label];
}
